import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  cardContent: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  listItem: {
    display: 'block',
  },
  skeletonContainer: {
    borderRadius: 0,
  },
});

export default useStyles;
